import React from 'react';
import { Flex, Box, Image, Text } from 'rebass/styled-components';

import iconHeart from '../../assets/images/icon-heart.svg';

const SmartDevices = () => (
  <Box bg="primaryLight">
    <Flex flexDirection="column" mx={[4, 5]} py={5}>
      <Box mb={3} mt={1}>
        <Image src={iconHeart}></Image>
      </Box>
      <Box>
        <Text fontSize={3} lineHeight="29px" fontFamily="lato" color="white">
          Smart devices can measure changes in your lifestyle and biometric
          data, like heart rate variability. When paired with algorithms, this
          data can help predict changes in lupus disease activity.
        </Text>
      </Box>
    </Flex>
  </Box>
);

export default SmartDevices;
